import { render, staticRenderFns } from "./registerNew.vue?vue&type=template&id=122372c6&scoped=true"
import script from "./registerNew.vue?vue&type=script&lang=js"
export * from "./registerNew.vue?vue&type=script&lang=js"
import style0 from "./registerNew.vue?vue&type=style&index=0&id=122372c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122372c6",
  null
  
)

export default component.exports